// extracted by mini-css-extract-plugin
module.exports = {"home-page":"home_home-page__3uu4J","video-grid":"home_video-grid__2RBsc"};